import type { AxiosInstance } from 'axios'

export default (api: AxiosInstance) => ({
    async putsActivity(payload: {
        uid: string
        shared: boolean
        channel: 'LINE'
        channelId: string
    }) {
        api.defaults.baseURL = process.env.THUNDER_CONNECT_API_V2 || ''

        api.post('/campaigns/line-sharing', { ...payload, dateTime: new Date().toISOString() })
    },
})
